// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_EmitResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for invoice emission
 */
import type { Invoice_EmitDocumentRow } from './Invoice_EmitDocumentRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_EmitResponseDados {
invoice_id?: number
external_id?: string
status?: string
invoice_number?: string
documents?: Invoice_EmitDocumentRow[]
}

export type Invoice_EmitResponse = ApiResponse<Invoice_EmitResponseDados>;

registerResponseContract('Invoice_EmitResponse', {
  invoice_id:     { type: 'number',  required: false },
  external_id:    { type: 'string',  required: false },
  status:         { type: 'string',  required: false },
  invoice_number: { type: 'string',  required: false },
  documents: {
    type: 'array',
    required: false,
    items: {
      invoice_id:     { type: 'number',  required: false },
      document_kind:  { type: 'string',  required: false },
      external_id:    { type: 'string',  required: false },
      status:         { type: 'string',  required: false },
      invoice_number: { type: 'string',  required: false },
    },
  },
})
